export const DASHBOARD_TAB_CONFIRMING = 'confirming';
export const DASHBOARD_TAB_FACTORING = 'factoring';

export type CurrencyViewModel = {
	Currency: string;
};

export type SeriesDetail = {
	name: string;
	value: string | number;
};

export type SeriesData = {
	name: string;
	series: SeriesDetail[];
};

export type DocumentForecastSeriesData = {
	PaymentState: string;
	TotalAmount: string;
};

export function transposeSeries(data: SeriesData[]): SeriesData[] {
	const dates: string[] = data.length > 0 ? data[0].series.map((detail) => detail.name) : [];
	return dates.map((date) => ({
		name: date,
		series: data.map((stateSeries) => ({
			name: stateSeries.name,
			value: stateSeries.series.find((detail) => detail.name === date)?.value ?? 0,
		})),
	}));
}
